import { Box } from '@mui/material';
import { ContractManagementAccordion } from './ContractManagementAccordion';
import { Fragment } from 'react';
import { useQuery } from 'react-query';
import { getSalesToolsContracts } from '../../../fetch';
import { Loader } from '../../../components';

export const ContractManagementList = () => {
  const { data, isLoading } = useQuery(['getSalesToolsContracts-contract-management'], () =>
    getSalesToolsContracts()
  );

  if (isLoading) {
    return <Loader position="centered" type="inline" />;
  }

  return (
    <Box>
      {data?.map(contract => {
        return (
          <Fragment key={contract.buildDocumentTypeId}>
            <ContractManagementAccordion contract={contract} />
          </Fragment>
        );
      })}
    </Box>
  );
};
